module.exports = __webpack_public_path__ + "img/LewisLanier.3553c699.png";